import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Search, ArrowUp } from "lucide-react";
import { ROUTES, CONTACT } from "./data";

export const MobileCTABar = () => (
  <div
    data-testid="mobile-cta-bar"
    className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white border-t border-[#E5E5E5] grid grid-cols-2 shadow-[0_-6px_24px_-12px_rgba(0,0,0,0.2)]"
  >
    <a
      href={`tel:${CONTACT.phoneTel}`}
      data-testid="mobilebar-call"
      className="flex items-center justify-center gap-2 py-3.5 text-[#254369] font-medium border-r border-[#E5E5E5]"
    >
      <Phone size={18} /> Call
    </a>
    <Link
      to={ROUTES.search}
      data-testid="mobilebar-search"
      className="flex items-center justify-center gap-2 py-3.5 bg-[#254369] text-white font-medium"
    >
      <Search size={18} /> Search Homes
    </Link>
  </div>
);

export const BackToTop = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 700);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <button
      data-testid="back-to-top"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Back to top"
      className="fixed bottom-20 lg:bottom-6 right-4 z-40 w-11 h-11 rounded-full bg-[#254369] text-white flex items-center justify-center shadow-lg hover:bg-[#2D2D37] transition-colors"
    >
      <ArrowUp size={20} />
    </button>
  );
};
